/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Stack } from "@fluentui/react";
import * as React from "react";

import { UserPersona } from "../../../../common/UserPersona";

import { getDateTimeAsString, getResponseMessage, getUserPersonaProps } from "./ManagerResponse.mappers";
import { getClassNames } from "./ManagerResponse.styles";
import { ManagerResponseProps } from "./ManagerResponseProps";

export const ManagerResponse: React.FC<ManagerResponseProps> = props => {
    const { managerMember, request } = props;
    const styles = getClassNames();

    const managerPersonaProps = getUserPersonaProps(request, managerMember);
    const responseMessage = getResponseMessage(request);

    const dateOfResponse = getDateTimeAsString(request?.lastModifiedTime);

    return (
        <Stack className={styles.stack}>
            <span className={styles.divider} />
            <Stack horizontal horizontalAlign="space-between">
                <UserPersona {...managerPersonaProps} />
                <Stack.Item className={styles.text}>{dateOfResponse ? dateOfResponse : null}</Stack.Item>
            </Stack>
            <Stack.Item className={styles.text}>{responseMessage}</Stack.Item>
        </Stack>
    );
};